import React, { MouseEventHandler } from 'react';
import EDLink from '../Link/EDLink';
import { useIsTouchDevice } from '../../Components/BreakpointContext/BreakpointContextUtils';
import { useIsFloatingMenuVisible } from '../../Components/FloatingBottomArea/FloatingMenu';
import EDBox from '../EDBox/EDBox';

interface IProps {
  onClick?: MouseEventHandler;
  caption: string;
  children?: never;
  disabled?: boolean;
}
/**
 * Breadcrumb är den enskilda länken i en lista. Jämför “breadcrumbs”, som är hela listan.
 */
const EDBreadcrumb: React.FunctionComponent<
  React.PropsWithChildren<IProps>
> = props => {
  const isTouchDevice = useIsTouchDevice();
  const floatingTouchLayout = useIsFloatingMenuVisible();

  return floatingTouchLayout ? (
    <EDBox
      sx={{
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
      }}
    >
      {props.caption}
    </EDBox>
  ) : (
    <EDLink
      onClick={props.disabled ? undefined : props.onClick}
      inheritStyle
      buttonComponent
      hint={isTouchDevice ? props.caption : undefined}
    >
      {props.caption}
    </EDLink>
  );
};

export default EDBreadcrumb;
